module.exports = __webpack_public_path__ + "img/arrow.a5f259e6.svg";